@if (isVisible == true) {
  <div class="position-absolute rightside">
    @if (isMinimazed == false) {
      <div class="">
        <h4 class="m-1 text-center pointer" (click)="maximize()">
          Your feedback matters
        </h4>
        <a class="btn btn-outline-dark btn-sm noborder toprightcorner position-absolute" (click)="close()">
          <i class="bi bi-x"></i>
        </a>
        <p class="m-1 text-body-secondary small">
          We develop Wroolo to your needs, so we highly appreciate if you tell us about you experience.
        </p>
        <p class="m-1">
          <textarea class="form-control" rows="4" placeholder="Enter your feedback" [(ngModel)]="feedbackContent"></textarea>
        </p>
        <a class="m-1 btn btn-outline-dark btn-sm noborder text-center" (click)="send()">
          <i class="bi bi-save"></i>
        </a>
      </div>
    }
    @if (isMinimazed == true) {
      <div class="">
        <a class="btn btn-outline-dark btn-sm noborder" (click)="close()">
          <i class="bi bi-x"></i>
        </a>
        <div class="m-1 verticalheader pointer" (click)="maximize()">
          Your feedback matters
        </div>
      </div>
    }
  </div>
}